import { Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const RootDiv = styled('div')({
  display: 'flex',
  gap: '8px',
  padding: '8px 16px',
  position: 'relative',
  borderBottom: '1px solid #EAEAEA',
  alignItems: 'center',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const SkeletonImg = styled(Skeleton)({
  width: '50px',
  height: '50px',
});

export const ImgProduct = styled('img')({
  height: '50px',
  width: '50px',
  cursor: 'pointer',
  objectFit: 'contain',
});

export const InfoDiv = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  minWidth: 0,
});

export const TitleTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '21px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const DetailsTextTypography = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  letterSpacing: '0.4px',
  lineHeight: '18px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#757575',
});

export const PriceContainer = styled('div')({
  display: 'flex',
  gap: '4px',
});

export const PriceTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isOldPrice',
})<{ isOldPrice?: boolean }>(({ isOldPrice, theme }) => ({
  color: isOldPrice ? theme.palette.text.disabled : theme.palette.text.primary,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '21px',
  textDecoration: isOldPrice ? 'line-through' : 'none',
}));
